import styled from "styled-components";
import {headerHeight} from "styles/constants";

export const MainContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: calc(100vh - ${headerHeight}px);
`
